import React, { Component, Fragment } from "react";
import Header from "./partials/Header";
import Footer from "./partials/Footer";
import {
  Container,
  Row,
  Col,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Fade,
  Alert,
  UncontrolledTooltip,
} from "reactstrap";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { boughtFinish, fetchGames } from "../redux/actions/gameActions";
import moment from "moment";
import { getVouchers } from "../redux/actions/voucherActions";
import { getUser, getUsers } from "../redux/actions/userActions";
import { getTeams } from "../redux/actions/teamActions";

export class MyGames extends Component {
  componentDidMount() {
    this.props.fetchGames();
    this.props.getUsers();
    setTimeout(() => {
      this.props.boughtFinish();
    }, 5000);
    this.props.getVouchers();
    let user = JSON.parse(localStorage.getItem("user_info"));
    this.props.getUser(user.id);
    this.props.getTeams(user.id);
  }
  getMyGames = () => {
    let myGames = null;
    let { game } = this.props;
    let user = JSON.parse(localStorage.getItem("user_info"));
    if (game.games != null && user != null) {
      myGames = [];
      let { my_games } = user;
      for (let mGame of my_games) {
        console.log(mGame);
        let obj =
          game.games != -1 && game.games.find((game) => game.id == mGame);
        if (obj != null && obj != false) myGames.push(obj);
      }
    }
    return myGames;
  };
  render() {
    var { vouchers, games, user, bought, teams, users } = this.props;
    return (
      <Fragment>
        <Header {...this.props} heading="My Games" />
        <Container className="bg-dark-1 margin-top-fix my-games-container mb-5">
          {bought ? (
            <Fade in={bought}>
              <Alert isOpen={bought} color="success">
                {"Game(s) bought Successfully!"}
              </Alert>
            </Fade>
          ) : null}
          {games &&
            user &&
            user.my_games &&
            games.length &&
            games
              .filter((game) => user.my_games.includes(game.id))
              .map((game) => (
                <>
                  <Row className="justify-content-center align-items-end">
                    <Col xl={4} lg={4} md={10} sm={12}>
                      <div
                        className="my-game-img my-game-img-1"
                        style={{ backgroundImage: `url(${game.img})` }}
                      ></div>
                    </Col>
                    <Col xl={6} lg={7} md={10} className="align-self-start">
                      <div className="text-white-1">
                        <CardBody>
                          <div className="d-flex">
                            <CardTitle tag="h5">{game.title}</CardTitle>
                            <div className="ms-auto">
                              <CardSubtitle className="mb-2 text-muted ">
                                {moment(game.start_date.toDate()).format(
                                  "DD MMM YYYY"
                                )}
                              </CardSubtitle>
                            </div>
                          </div>
                          <CardSubtitle className="mt-2">
                            <b>Vouhcer Codes :&nbsp;</b>
                            {vouchers &&
                              vouchers
                                .filter((voucher) => voucher.game_id == game.id && voucher.user_id==JSON.parse(localStorage.getItem("user_info")).id)
                                .map((voucher, index,array) => {
                                  if(index==0){
                                    if (voucher.isUsed) {
                                    return (
                                      <>
                                        
                                        <span
                                          id={
                                            "UncontrolledTooltipExample" + index
                                          }
                                          className="text-danger"
                                        >
                                          {voucher.voucher_code + "  "}
                                        </span>
                                        <UncontrolledTooltip
                                          placement="top"
                                          target={
                                            "UncontrolledTooltipExample" + index
                                          }
                                        >
                                          Voucher is used!
                                        </UncontrolledTooltip>
                                      </>
                                    );
                                  } else {
                                    return (
                                      <>
                                        {" "}
                                        <span
                                          id={
                                            "UncontrolledTooltipExample" + index
                                          }
                                          className="text-success"
                                        >
                                          {voucher.voucher_code + "  "}
                                        </span>
                                        <UncontrolledTooltip
                                          placement="top"
                                          target={
                                            "UncontrolledTooltipExample" + index
                                          }
                                        >
                                          Voucher is not used!
                                        </UncontrolledTooltip>
                                      </>
                                    );
                                  }
                                  }else{
                                    if (voucher.isUsed) {
                                    return (
                                      <>
                                        
                                        <span
                                          id={
                                            "UncontrolledTooltipExample" + index
                                          }
                                          className="text-danger"
                                        >
                                          {",  "+voucher.voucher_code + "  "}
                                        </span>
                                        <UncontrolledTooltip
                                          placement="top"
                                          target={
                                            "UncontrolledTooltipExample" + index
                                          }
                                        >
                                          Voucher is used!
                                        </UncontrolledTooltip>
                                      </>
                                    );
                                  } else {
                                    return (
                                      <>
                                        {" "}
                                        <span
                                          id={
                                            "UncontrolledTooltipExample" + index
                                          }
                                          className="text-success"
                                        >
                                          {",  "+voucher.voucher_code + "  "}
                                        </span>
                                        <UncontrolledTooltip
                                          placement="top"
                                          target={
                                            "UncontrolledTooltipExample" + index
                                          }
                                        >
                                          Voucher is not used!
                                        </UncontrolledTooltip>
                                      </>
                                    );
                                  }
                                  }
                                  
                                })}
                            <br />
                            {game.address}
                          </CardSubtitle>
                          <CardSubtitle className="mt-3 my-game-desc">
                            {teams &&
                              teams
                                .filter((team) => team.game_id == game.id)
                                .map((team, index) => {
                                  return (
                                    <>
                                      Team {index + 1}
                                      <br />
                                      Team Name : {team.team_name}
                                      <br />
                                      <CardSubtitle className=" my-game-desc">
                                        Team Member :
                                        {users &&
                                          users.find(
                                            (us) => us.id == team.leader_id
                                          ).full_name}
                                        ,
                                        {users &&
                                          team.members.map((mem, index) => {
                                            if (
                                              index ==
                                              team.members.length - 1
                                            ) {
                                              return (
                                                users &&
                                                users.find((us) => us.id == mem)
                                                  .full_name + ","
                                              );
                                            } else {
                                              return (
                                                users &&
                                                users.find((us) => us.id == mem)
                                                  .full_name
                                              );
                                            }
                                          })}
                                      </CardSubtitle>
                                    </>
                                  );
                                })}
                          </CardSubtitle>

                          <CardSubtitle
                            tag="h6"
                            className="mb-2 text-muted mt-3"
                            style={{ lineHeight: 1.5 }}
                          >
                            About : {game.case_incident}
                          </CardSubtitle>
                        </CardBody>
                      </div>
                    </Col>
                    <Col xl={2} lg={2} md={3} sm={4} xs={5}>
                      <div className="text-center">
                        {/* <Button className="bg-purple-2 text-green-1 mt-3 mt-xl-0" style={{ borderRadius: 10 }}><i className="fa fa-share-alt px-2"></i><span className="px-2">Share</span> </Button> */}
                      </div>
                    </Col>
                  </Row>
                  <br/>
                  {/* <Row className="mt-5 justify-content-center px-0 px-md-4">
                    <Col xl={3} lg={6} md={6} sm={8}>
                      <div className="my-game-team my-game-team-1 mx-3 mx-sm-0">
                        <h4 className="text-red-1 text-center">
                          <b>Your Photo With Your Team</b>
                        </h4>
                      </div>
                    </Col>
                    <Col xl={3} lg={6} md={6} sm={8}>
                      <div className="my-game-team my-game-team-2 mx-3 mx-sm-0"></div>
                    </Col>
                    <Col xl={3} lg={6} md={6} sm={8}>
                      <div className="my-game-team my-game-team-3 mt-4 mt-xl-0 mx-3 mx-sm-0"></div>
                    </Col>
                    <Col xl={3} lg={6} md={6} sm={8}>
                      <div className="my-game-team my-game-team-4 mt-4 mt-xl-0 mx-3 mx-sm-0"></div>
                    </Col>
                  </Row> */}
                </>
              ))}
        </Container>
        <Footer />
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    game: state.game,
    bought: state.game.bought,
    games: state.game.games,
    vouchers: state.voucher.vouchers,
    user: state.auth.user,
    users: state.user.users,
    teams: state.team.teams,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchGames: () => dispatch(fetchGames()),
    boughtFinish: () => dispatch(boughtFinish()),
    getVouchers: () => dispatch(getVouchers()),
    getUser: (uid) => dispatch(getUser(uid)),
    getUsers: () => dispatch(getUsers()),
    getTeams: (uid) => dispatch(getTeams(uid)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MyGames);
